import { type ReactNode, useEffect } from 'react'
import { X } from 'lucide-react'

interface ModalProps {
  acik: boolean
  onKapat: () => void
  baslik: string
  children: ReactNode
  /** Geniş modal (form vs.) için 'lg', normal için 'md' */
  boyut?: 'md' | 'lg'
}

export function Modal({ acik, onKapat, baslik, children, boyut = 'md' }: ModalProps) {
  useEffect(() => {
    if (!acik) return

    // ESC ile kapat
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onKapat()
    }
    document.addEventListener('keydown', handleEsc)

    // Scroll lock
    document.body.style.overflow = 'hidden'

    return () => {
      document.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [acik, onKapat])

  if (!acik) return null

  const widthClass = boyut === 'lg' ? 'max-w-2xl' : 'max-w-md'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onKapat}
      />

      {/* Modal */}
      <div
        className={`relative bg-white rounded-2xl shadow-2xl w-full ${widthClass} max-h-[90vh] flex flex-col animate-slide-up`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-bold text-gray-900">{baslik}</h2>
          <button
            onClick={onKapat}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Kapat"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Body — scrollable */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {children}
        </div>
      </div>
    </div>
  )
}
